import { IProductsColors, IProductsSizes } from "../../../types/resource.types";

export interface IProductProperties {
  [key: string]: {
    images: any[];
    sizes: {
      [key: string]: number;
    };
  };
}

export interface IReactAdminProperty {
  color: keyof IProductsColors;
  images: any[];
  sizes: {
    size: keyof IProductsSizes;
    quantity: number;
  }[];
}

export enum IFileStatus {
  pending = "pending",
  success = "success",
  error = "error",
}

export type IReactAdminProperties = IReactAdminProperty[];
